<template>
	<div class="body">
		<div class="body-container">

			<template v-if="data">
				<div class="title-ctr">{{data.title}}</div>

				<el-table :data="data.list" border stripe>
					<!-- 固定列：省份名称 -->
					<el-table-column label="省直辖市" align="center" prop="province_name"/>

					<!-- 动态列：年份从后台返回 -->
					<el-table-column v-for="year in data.columnList" :key="year" :label="year + ''" align="center"
						min-width="100">
						<template v-slot="{ row }">
							<label class="edit-label"
								@click="clickChangeData(row.province_code, year, row.name + '招生人数', '')">{{ getNumValue(row, year) }}</label>
						</template>
					</el-table-column>
				</el-table>
				<div class="source-note">注：表数据来源于统计年鉴，<label style="color: red;">如有错误，可点击修正</label>。</div>



			</template>

		</div>

		<div class="action-ctr">
			<el-button type="primary" icon="el-icon-right" size='medium' @click="clickNext()"
				class="next-btn">下一步</el-button>
		</div>

		<el-dialog title="原理介绍" :visible.sync="showIntroDialog" append-to-body v-if="showIntroDialog" align="center">

			<div class="rich-ctr">
				<div class="rich-value" v-html="introDialog.value"></div>
			</div>


			<div slot="footer" class="dialog-footer" align="center">
				<el-button type="primary" @click="clickCloseIntroDialog()">确 定</el-button>
			</div>
		</el-dialog>
		<el-dialog :title="dataTitle" :visible.sync="showDataDialog" append-to-body v-if="showDataDialog"
			align="center">

			<div class="data-ctr">
				<el-input v-model="dataValue" placeholder="请输入数值" class="data-input" />
			</div>


			<div slot="footer" class="dialog-footer" align="center">
				<el-button type="primary" @click="clickConfirmData()">确 定</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import {
		getFitCalcuEnrollPageData,
		updateDvnData
	} from "@/api/service"

	import {
		getSpanMap,
		isEmpty
	} from "@/utils/util"

	import {
		Notification,
		Message,
		Loading
	} from 'element-ui'

	import {
		parse,
		handleProtocal,
		handleRouteProtocal
	} from "@/utils/protocal"

	export default {
		name: "Famous",
		data() {
			return {
				params: {
					page: 1,
					pageSize: 20
				},
				data: null,
				showIntroDialog: false,
				introDialog: null,
				variableType: {
					File: 2,
					Rich: 3
				},
				showDataDialog: false,
				dataTitle: '',
				dataValue: ''
			}
		},
		created() {
			this.initPageData();
		},

		methods: {
			initPageData() {
				this.params['id'] = this.$route.query.id;
				this.requestData();
			},

			buildParams() {
				this.params['rowId'] = this.rowId;
				this.params['field'] = this.field;
				this.params['type'] = 'enroll';
				this.params['value'] = this.dataValue;
				this.params['year'] = this.year;
				return this.params;
			},

			requestData() {
				getFitCalcuEnrollPageData(this.buildParams()).then(res => {
					let realData = res.data;
					this.data = realData;
				});
			},

			clickNext() {
				let path = '/fit_industry_calcu?id=' + this.params['id']
				this.$router.push(path);
			},

			clickRule(route) {
				if (route.type == this.variableType.File) {
					let path = route.path;
					window.open(path, '_blank')
				} else if (route.type == this.variableType.Rich) {
					this.showIntroDialog = true;
					this.introDialog = route;
				}
			},

			clickCloseIntroDialog() {
				this.showIntroDialog = false;
			},


			clickChangeData(id, year, field, name, value) {
				let title = year + '年' + name;

				title += '数据修改';

				this.rowId = id;
				this.year = year;
				this.field = field;
				this.dataTitle = title;
				this.dataValue = value;
				this.showDataDialog = true;
			},

			clickConfirmData() {
				updateDvnData(this.buildParams()).then(res => {
					this.requestData();
					this.showDataDialog = false;
				})
			},

			getNumValue(row, year) {
				// 安全访问，逐级判断
				if (row && row.map && row.map[year] && row.map[year]['num'] !== undefined) {
					return row.map[year]['num'];
				}
				return 0; // 默认值
			}
		}
	}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
	@use "fit_enroll_calcu.scss";
</style>